export default __webpack_public_path__ + "static/media/join_event_processing.ab57a6e4.gif";